// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { useDispatch } from 'react-redux'
import { SubmissionError } from 'redux-form'
import { UNCAUGHT_ERROR } from 'errors'
import { createAndUpdateComments } from 'redux/modules/databaseDetails'
import { useModalContext } from 'components'

const useHandleCreateComment = (createCallback, pathComment) => {
  const dispatch = useDispatch()

  const { closeContextModal } = useModalContext()

  return async formValues => {
    try {
      const newComment = await dispatch(createAndUpdateComments(formValues, pathComment))
      createCallback(newComment)
      closeContextModal()
    } catch (err) {
      console.warn(err)
      const _error = err.message || UNCAUGHT_ERROR
      throw new SubmissionError({ _error })
    }
  }
}

export default useHandleCreateComment
